<template>
  <div class="wrapper-auth">
    <div class="login__info">
      <h1>STARPETS Control Center</h1>
    </div>
    <div class="auth">
      <form @submit.prevent>
        <div class="auth-block__header">
          <h1>Sign In to Control Center</h1>
        </div>
        <div class="auth-block__content">
          <div class="auth-block__content__input">
            <div class="auth-block__content__input-label">
              <img src="../../assets/images/login.svg" alt="" />
              <small>Username</small>
            </div>
            <div class="auth-block__content__input-wrapper">
              <input
                type="text"
                v-model="auth.email"
                autocomplete="off"
                placeholder="Enter login"
              />
            </div>
          </div>
          <div class="auth-block__content__input">
            <div class="auth-block__content__input-label">
              <img src="../../assets/images/login.svg" alt="" />
              <small>Password</small>
            </div>
            <div class="auth-block__content__input-wrapper">
              <input
                type="password"
                v-model="auth.password"
                autocomplete="off"
                placeholder="Enter password"
              />
              <div class="auth-block__content__input-wrapper__show" @click="togglePassword">
                <img src="../../assets/images/eye.svg" />
              </div>
            </div>
          </div>
          <div class="auth-block__content__input">
            <div class="auth-block__content__input-label">
              <img src="../../assets/images/login.svg" alt="" />
              <small>2FA</small>
            </div>
            <div class="auth-block__content__input-wrapper">
              <input type="number" v-model="auth.twoFA" autocomplete="off" placeholder="2FA" />
            </div>
          </div>
          <small :class="{ 'show-err': !errors.show }">
            {{ errors.message }}
          </small>
          <div class="auth-block__content__button">
            <button @click="prepareForSignIn" v-if="isLoaded">Sign in</button>
            <button v-else>
              <svg
                width="21"
                height="20"
                viewBox="0 0 21 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20.6036 9.38109C20.5914 9.12074 20.4764 8.87588 20.2837 8.70036C20.091 8.52485 19.8365 8.43306 19.5762 8.44519C19.3158 8.45732 19.071 8.57237 18.8955 8.76504C18.7199 8.95771 18.6281 9.21222 18.6403 9.47256C18.7229 11.2296 18.2129 12.9635 17.1919 14.3959C16.1709 15.8283 14.6983 16.8762 13.0104 17.3712C11.3225 17.8663 9.51719 17.7799 7.88427 17.1259C6.25136 16.4719 4.88553 15.2882 4.00602 13.7649C3.12651 12.2415 2.78434 10.4669 3.03441 8.72571C3.28449 6.98456 4.11232 5.37792 5.38502 4.16369C6.65772 2.94946 8.30148 2.19805 10.0525 2.03007C11.8034 1.86209 13.5601 2.28729 15.0404 3.23741C15.149 3.30707 15.2703 3.35464 15.3974 3.37743C15.5244 3.40021 15.6547 3.39775 15.7807 3.37018C15.9068 3.34262 16.0262 3.29049 16.1321 3.21678C16.2381 3.14307 16.3284 3.04922 16.3981 2.94058C16.4678 2.83195 16.5153 2.71065 16.5381 2.58363C16.5609 2.45661 16.5584 2.32634 16.5309 2.20027C16.5033 2.07419 16.4512 1.95479 16.3775 1.84886C16.3038 1.74293 16.2099 1.65256 16.1013 1.5829C14.2507 0.395893 12.055 -0.135003 9.86659 0.0754093C7.67815 0.285822 5.62385 1.22534 4.03335 2.74319C2.44286 4.26105 1.4084 6.26922 1.096 8.44544C0.783584 10.6217 1.21134 12.8398 2.3106 14.7437C3.40987 16.6477 5.11691 18.1272 7.15778 18.9448C9.19865 19.7623 11.455 19.8705 13.5648 19.2521C15.6745 18.6336 17.5153 17.3243 18.7917 15.5342C20.0682 13.7442 20.7063 11.5772 20.6036 9.38109Z"
                  fill="white"
                />
              </svg>
            </button>
          </div>
        </div>
      </form>
    </div>
    <Captcha
      v-if="captcha.display"
      @hideCaptcha="() => (captcha.display = false)"
      @onVerify="logIn"
    />
  </div>
</template>

<script>
import Captcha from '../../components/Captcha/Captcha'
import http from './../../utils/http'
import './auth.scss'

export default {
  name: 'Auth',
  components: { Captcha },
  data() {
    return {
      isLoaded: true,
      captcha: {
        display: false
      },
      auth: {
        email: '',
        password: '',
        twoFA: '',
        hcaptcha: 'SVm349jgfgSFD023kr6j7zSldSi23Fkdsf92kf9F84j'
      },
      errors: {
        show: false,
        message: 'Неверный ключ'
      }
    }
  },
  methods: {
    prepareForSignIn() {
      if (!this.auth.password.length || !this.auth.email.length) return

      this.captcha.display = true
    },

    async logIn(token) {
      this.captcha.display = false
      this.isLoaded = false

      // const requestPayload = {
      //   email: this.auth.email,
      //   password: this.auth.password,
      //   hcaptcha: this.auth.hcaptcha
      // };

      const response = await http.post(`https://auth.apineural.com/api/user/login`, {
        email: this.auth.email,
        password: this.auth.password,
        topt: this.auth.twoFA,
        captcha: token,
        captcha_method: 'cloudflare',
        cloudflare: token
      })

      if (response.statusCode === 200) {
        this.errors.show = false
        const { access_token, refresh_token } = response.data
        this.$store.commit('setTokens', { access_token, refresh_token })
        // this.getAdminStatus()
        await this.$router.push('/dashboard')
      } else {
        this.errors.show = true
        this.errors.message = response.data.message
      }

      this.isLoaded = true

      // fetch("https://auth.starpets.gg/api/user/login", {
      //   method: "POST",
      //   headers: {
      //     "Content-Type": "application/json",
      //     accept: "application/json",
      //   },
      //   body: JSON.stringify(requestPayload),
      // })
      //   .then((res) => res.json())
      //   .then((data) => {
      //     if (data.message) {
      //       this.errors.show = true;
      //       this.errors.message = data.message;
      //     } else {
      //       this.errors.show = false;
      //
      //       const { access_token, refresh_token } = data;
      //       this.$store.commit("setTokens", { access_token, refresh_token });
      //
      //       this.$router.push("/dashboard");
      //
      //       // this.$toast.success("Вы вошли в роли Поддержки", {
      //       //   timeout: 2000,
      //       // });
      //     }
      //
      //     this.isLoaded = true;
      //   });
    },
    togglePassword(event) {
      const input = event.target
        .closest('.auth-block__content__input-wrapper__show')
        .parentNode.querySelector('input')

      if (input.type === 'text') {
        input.type = 'password'
        event.target.src = require('../../assets/images/eye.svg')
        event.target.classList.remove('open')
      } else {
        input.type = 'text'
        event.target.src = require('../../assets/images/eye-opened.svg')
        event.target.classList.add('open')
      }
    }
  }
}
</script>
